import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    style: translate({ id: 'rm.contextual.depot.style' }),
    styleAll: translate({ id: 'rm.contextual.depot.styleAll' }),
  }))

  return api
}
